<mat-dialog-content *transloco="let t">
    <div class="modal-header border-b border-gray-200 px-4 pb-3 bg-white">
        <h2 class="text-xl font-semibold text-gray-800 leading-tight">{{t("Create task")}} {{data?.title !== '' ? "
            for"+data?.title : "" }}</h2>
        <p class="text-secondary">
            {{data?.lwId ? "ID: "+data?.lwId : ""}}
        </p>
    </div>
    <form [formGroup]="createTaskForm" class="w-full pt-4">
        <mat-form-field class="w-full" [floatLabel]="'always'">
            <mat-label>{{t("Title")}}</mat-label>
            <input matInput [formControlName]="'title'" required class="w-full" [placeholder]="t('Title')" />
            <mat-error *ngIf="createTaskForm.get('title').hasError('required')" class="text-red-500">
                {{t("Title is required")}}
            </mat-error>
        </mat-form-field>
        <!-- Assign -->
        <div>
            <div class="font-medium mb-1.5">{{t("Assign To")}}</div>
            <div class="grid grid-cols-2 gap-2">
                <div class="flex col-span-2 sm:col-span-1">
                    <mat-form-field class="flex-auto" [floatLabel]="'always'">
                        <mat-label>{{t("Assign to")}}</mat-label>
                        <mat-select [placeholder]="'Assign to'" [required]="true" [formControlName]="'assignedToType'"
                            [placeholder]="t('Assign to')" (selectionChange)="onAssignToChange($event)">
                            <mat-option [value]="'user'">{{t("User")}}</mat-option>
                            <mat-option [value]="'team'">{{t("Team")}}</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:cursor-click'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="flex col-span-2 sm:col-span-1">
                    <mat-form-field class="flex-auto" *ngIf="showUserSelection" [floatLabel]="'always'">
                        <mat-label>{{t("Select user")}}</mat-label>
                        <mat-select [placeholder]="t('Select user')" [formControlName]="'assignedTo'"
                            [placeholder]="t('Select user')">
                            <div class="input-wrapper flex items-center">
                                <input
                                    class="shadow appearance-none border border-r-0 text-lg w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    matInput [placeholder]='t("Search user")' [(ngModel)]="searchValue"
                                    [ngModelOptions]="{ standalone: true }" (keydown)="$event.stopPropagation()">
                            </div>

                            <mat-option [value]="">{{t("Please select")}}</mat-option>
                            <mat-option
                                *ngFor="let user of userList | fuseSelectSearch : searchValue : '[TASK SEARCH USER]'"
                                [value]="user.id">
                                {{ user.lastName }} {{ user.firstName }}
                            </mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user-group'"></mat-icon>
                    </mat-form-field>
                    <mat-form-field class="flex-auto" *ngIf="showTeamSelection">
                        <mat-select [placeholder]="'Select team'" [formControlName]="'assignedTo'">
                            <mat-option *ngFor="let team of teamList" [value]="team._id">
                                {{ team.name }}
                            </mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user-group'"></mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!-- Priority and Due date -->
        <div class="flex flex-wrap items-center py-3">

            <!-- Priority -->
            <div>
                <div class="font-medium">{{t("Priority")}}</div>
                <div class="flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer"
                    [ngClass]="{'text-green-800 bg-green-200 dark:text-green-100 dark:bg-green-500': createTaskForm.get('priority').value === 0,
                          'text-gray-800 bg-gray-200 dark:text-gray-100 dark:bg-gray-500': createTaskForm.get('priority').value === 1,
                          'text-red-800 bg-red-200 dark:text-red-100 dark:bg-red-500': createTaskForm.get('priority').value === 2}" [matMenuTriggerFor]="priorityMenu">

                    <!-- Low -->
                    <ng-container *ngIf="createTaskForm.get('priority').value === 0">
                        <mat-icon class="icon-size-5 text-current"
                            [svgIcon]="'heroicons_solid:arrow-narrow-down'"></mat-icon>
                        <span class="ml-2 mr-1 text-md font-medium">{{t("Low")}}</span>
                    </ng-container>

                    <!-- Normal -->
                    <ng-container *ngIf="createTaskForm.get('priority').value === 1">
                        <mat-icon class="icon-size-4 text-current" [svgIcon]="'heroicons_solid:minus'"></mat-icon>
                        <span class="ml-2 mr-1 text-md font-medium">{{t("Normal")}}</span>
                    </ng-container>

                    <!-- High -->
                    <ng-container *ngIf="createTaskForm.get('priority').value === 2">
                        <mat-icon class="icon-size-4 text-current"
                            [svgIcon]="'heroicons_solid:arrow-narrow-up'"></mat-icon>
                        <span class="ml-2 mr-1 text-md font-medium">{{t("High")}}</span>
                    </ng-container>
                </div>
                <mat-menu #priorityMenu="matMenu">
                    <!-- Low -->
                    <button [ngClass]="{'bg-hover': createTaskForm.get('priority').value === 0}" mat-menu-item
                        (click)="setTaskPriority(0)">
                        <span class="inline-flex items-center justify-between w-full min-w-30 leading-5">
                            <span class="font-medium">{{t("Low")}}</span>
                            <mat-icon class="mr-0 icon-size-4 text-green-600 dark:text-green-500"
                                [svgIcon]="'heroicons_solid:arrow-narrow-down'"></mat-icon>
                        </span>
                    </button>

                    <!-- Normal -->
                    <button [ngClass]="{'bg-hover': createTaskForm.get('priority').value === 1}" mat-menu-item
                        (click)="setTaskPriority(1)">
                        <span class="inline-flex items-center justify-between w-full min-w-30 leading-5">
                            <span class="font-medium">{{t("Normal")}}</span>
                            <mat-icon class="mr-0 icon-size-4 text-gray-600 dark:text-gray-500"
                                [svgIcon]="'heroicons_solid:minus'"></mat-icon>
                        </span>
                    </button>

                    <!-- High -->
                    <button [ngClass]="{'bg-hover': createTaskForm.get('priority').value === 2}" mat-menu-item
                        (click)="setTaskPriority(2)">
                        <span class="inline-flex items-center justify-between w-full min-w-30 leading-5">
                            <span class="font-medium">{{t("High")}}</span>
                            <mat-icon class="mr-0 icon-size-4 text-red-600 dark:text-red-500"
                                [svgIcon]="'heroicons_solid:arrow-narrow-up'"></mat-icon>
                        </span>
                    </button>
                </mat-menu>
            </div>

            <!-- Due date -->
            <div class="ml-6">
                <div class="font-medium">{{t("Due date")}}</div>
                <div class="relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer"
                    [ngClass]="{'text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700': !createTaskForm.get('dueDate').value,
                          'text-green-800 bg-green-200 dark:text-green-100 dark:bg-green-500': createTaskForm.get('dueDate').value && !isOverdue(),
                          'text-red-800 bg-red-200 dark:text-red-100 dark:bg-red-500': createTaskForm.get('dueDate').value && isOverdue()}" (click)="dueDatePicker.open()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:calendar'"></mat-icon>
                    <span class="ml-2 text-md font-medium">
                        <ng-container *ngIf="createTaskForm.get('dueDate').value">{{createTaskForm.get('dueDate').value
                            | date:'longDate'}}</ng-container>
                        <ng-container *ngIf="!createTaskForm.get('dueDate').value">{{t("Not set")}}</ng-container>
                    </span>
                    <mat-form-field
                        class="fuse-mat-no-subscript fuse-mat-dense invisible absolute inset-0 -mt-2.5 opacity-0 pointer-events-none">
                        <input matInput [formControlName]="'dueDate'" [matDatepicker]="dueDatePicker">
                        <mat-datepicker #dueDatePicker>
                            <mat-datepicker-actions>
                                <button mat-button (click)="createTaskForm.get('dueDate').setValue(null)"
                                    matDatepickerCancel>{{t("Clear")}}
                                </button>
                                <button class="" mat-flat-button [color]="'primary'" matDatepickerApply>Select
                                </button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

        </div>
        <mat-form-field class="w-full">
            <mat-label>{{t("Description")}}</mat-label>
            <textarea matInput [formControlName]="'description'" required class="w-full">
      </textarea>
            <mat-error *ngIf="createTaskForm.get('description').hasError('required')" class="text-red-500">
                {{t("Description is required")}}
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between" *transloco="let t">
    <button mat-stroked-button mat-dialog-close>{{t("Cancel")}}</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" class="fuse-mat-button-rounded">
        {{t("Create")}}
    </button>
</mat-dialog-actions>